<template>
  <ctnList :search_bar="true"/>
</template>

<script>
import ctnList from "@/components/portal/global/ContainerList";
export default {
  components: {
    ctnList
  },
};
</script>

